import { type ReactNode } from "react";
import HelpTip from "./HelpTip";

// 흰 표면 컨테이너: 폼 패널처럼 배경에서 떠 있어야 하는 영역에만 쓴다.
// 표는 Table 이 자체 테두리를 갖고 있으므로 Card 로 한 번 더 감싸지 않는다.
export function Card({
  className = "",
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={`rounded-lg border border-slate-200 bg-white ${className}`}>
      {children}
    </div>
  );
}

// 섹션 머리: 제목(왼쪽) + 액션/필터(오른쪽) 한 줄.
// 제목 위에 소제목 라벨(eyebrow)을 두지 않는다. 좌측 nav 가 이미 위치를 알려준다.
export function SectionHeader({
  title,
  count,
  children,
}: {
  title: string;
  count?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-baseline gap-2">
        <h2 className="text-lg font-semibold tracking-tight text-slate-900">
          {title}
        </h2>
        {count != null && (
          <span className="text-sm tabular-nums text-slate-400">{count}</span>
        )}
      </div>
      {children && (
        <div className="flex flex-wrap items-center gap-2">{children}</div>
      )}
    </div>
  );
}

// 오류 배너: 섹션 단위 실패를 본문 위에 고정된 자리로 보여준다 (빨간 문장 한 줄 대신).
export function ErrorBanner({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
      {children}
    </p>
  );
}

// 라벨 + 값 한 줄: 팝업·상세의 읽기 전용 정보에 쓴다.
// help 를 주면 라벨 옆 ⓘ 에 마우스를 올리거나 누르면 설명이 보인다 (HelpTip).
export function InfoRow({
  label,
  help,
  children,
}: {
  label: string;
  help?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex gap-3 text-sm">
      <span className="w-32 shrink-0 text-slate-500">
        {label}
        {help && <HelpTip text={help} />}
      </span>
      <span className="min-w-0 break-all text-slate-900">{children}</span>
    </div>
  );
}
